<template>
  <div class="disputes-digital-goods-info">
    <div class="fields">
      <div class="column">
        <FieldValue
          :field-value="formatDateWithTimezone(evidence.digital_goods_details.purchase_date)"
          :field-name="$t('fieldNames.purchaseDate')"
        />
        <FieldValue
          :field-value="evidence.digital_goods_details.purchase_details"
          :field-name="$t('fieldNames.purchaseDetails')"
        />
      </div>
      <div class="column">
        <FieldValue
          :field-value="evidence.digital_goods_details.refund_policy_details"
          :field-name="$t('fieldNames.refundPolicyDetails')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FieldValue from "@/components/common/FieldValue.vue";
import Formatter from "@/app/utils/common/functions/formatter";

export default {
  name: "DisputeViewDigitalGoods",
  components: {FieldValue},
  props: {
    evidence: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDateWithTimezone(date) {
      return Formatter.format({type: 'zonedDate', data: date})
    }
  }
}
</script>

<style lang="scss">
.disputes-digital-goods-info {

  & .fields {
    display: flex;

    & .column {
      text-align: left;
      flex: 1;
    }
  }
}
</style>